import React from 'react';
import { observer } from 'mobx-react';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { ConnectionTypeField } from '../../connections-list/_connection-form/connection-form-body/common-fields/connection-type.field';
import { FormFieldInput } from '../../../../../global/form/form-field-input/form-field-input';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { applyText, cancelText } from '../../../../../../constants/common-labels.constants';
import { PanelistLinkChildConnectionVM } from './panelist-link-child-connection.viewmodel';
import { ChildPanelistLinkFieldKey, FORM_CONFIG } from './panelist-link-child-connection.config';

export const PanelistLinkChildConnectionPresentation = observer((props: {vm: PanelistLinkChildConnectionVM}) => {
    const { vm } = props;

    const {
        label,
        attendeeId,
        attendeeEmail,
        connectionLink,
        connectionId,
        connectionPassword,
        connectionAccount,
        participantId,
    } = vm.getFormFields(ChildPanelistLinkFieldKey);

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form'>
                    <div className='oe-form__body'>
                        <ConnectionTypeField value={vm.type} />
                        <FormFieldInput.Text
                            field={attendeeId}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.ATTENDEE_ID].labelDescriptor}
                            disabled
                        />
                        <FormFieldInput.Text
                            field={label}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.LABEL].labelDescriptor}
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={connectionId}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.WEBINAR_ID].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Text
                            field={attendeeEmail}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.ATTENDEE_EMAIL].labelDescriptor}
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={connectionLink}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.CONNECTION_LINK].labelDescriptor}
                            withError
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={connectionPassword}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.CONNECTION_PASSWORD].labelDescriptor}
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={connectionAccount}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.CONNECTION_ACCOUNT].labelDescriptor}
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={participantId}
                            labelDescriptor={FORM_CONFIG[ChildPanelistLinkFieldKey.PARTICIPANT_ID].labelDescriptor}
                            withCopyBtn
                        />
                    </div>
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={applyText()}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.updateChildConnection.bind(vm)}
                        disabled={vm.isLoading}
                    />
                    <DefaultCloseSubWindowButton text={cancelText()} />
                </div>
            }
        />
    );
});